import { useRef, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import swal from 'sweetalert';
// component
import Iconify from '../../../components/Iconify';
import { TrainingCancellationAndApprove } from '../../../common/api-service';

// ----------------------------------------------------------------------
const TrainingCancellationMoreMenu = ({ data, handleRefresh, currentStatus }) => {
  const navigate = useNavigate();

  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState(data);
  const [open, setOpen] = useState(false);
  const [openApprove, setApproveOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [approveAmount, setApproveAmount] = useState('');

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setRejectReason('');
    setApproveAmount('');
    setOpen(false);
  };

  const handleApproveOpen = () => {
    setApproveOpen(true);
  };
  const handleApproveClose = () => {
    setRejectReason('');
    setApproveAmount('');
    setApproveOpen(false);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const handleEdit = () => {
    const setid = id;
    localStorage.setItem('getGroomingCancellationID', setid);
  };
  const handleDelete = () => {
    const payload = {
      _id: id,
      status: open ? 'rejected' : 'approved',
      reason_by_admin: rejectReason,
      cancellation_amount: approveAmount,
    };
    return TrainingCancellationAndApprove(payload).then((res) => {
      if (res.data.status === true) {
        swal({
          title: res.data.message,
          icon: 'success',
          timer: 2000,
          button: false,
        });
        setOpen(false);
        setApproveOpen(false);
        handleRefresh((preval) => {
          return !preval;
        });
      } else {
        swal({
          title: res.data.message,
          icon: 'danger',
          timer: 2000,
          button: false,
        });
      }
    });
  };

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <TextareaAutosize
            value={rejectReason}
            id="outlined-basic"
            minRows={3}
            label="Reason"
            variant="outlined"
            placeholder="Reason"
            onChange={(e) => setRejectReason(e.target.value)}
            style={{ width: '100%' }}
          />
          <Button variant="contained" onClick={handleDelete} sx={{ marginRight: '1rem' }}>
            Submit
          </Button>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
        </Box>
      </Modal>

      <Modal
        open={openApprove}
        onClose={handleApproveClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <TextField
            value={approveAmount}
            id="outlined-basic"
            label="Cancellation Amount"
            variant="outlined"
            name="amount"
            type="number"
            onChange={(e) => setApproveAmount(e.target.value)}
            style={{ width: '100%', marginBottom: '1rem' }}
          />
          <Button variant="contained" onClick={handleDelete} sx={{ marginRight: '1rem' }}>
            Submit
          </Button>
          <Button variant="outlined" onClick={handleApproveClose}>
            Cancel
          </Button>
        </Box>
      </Modal>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' },
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <Iconify
              icon={currentStatus === 'disabled' ? 'clarity:success-standard-solid' : 'eva:trash-2-outline'}
              width={24}
              height={24}
            />
          </ListItemIcon>
          <ListItemText primary="Reject" primaryTypographyProps={{ variant: 'body2' }} onClick={handleOpen} />
        </MenuItem>

        <MenuItem sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <Iconify icon="eva:edit-fill" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Approve" primaryTypographyProps={{ variant: 'body2' }} onClick={handleApproveOpen} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default TrainingCancellationMoreMenu;
